<template lang="html">
  <div>
    <nav class="main__menu__desktop hidden-sm-and-down">
      <ul>
        <li class="has__subnav">
          <router-link to="/coach/">
            <div class="has__subnav__icon">
              <DashboardIcon
                width="22px"
                height="22px"
                color="#7E7E7E"
              />
            </div>
            <span class="nav__text">
                Dashboard
            </span>
          </router-link>
        </li>
        <li class="has__subnav">
          <router-link to="/coach/coachschedules">
            <div class="has__subnav__icon">
              <BookacoachIcon
                width="22px"
                height="22px"
                color="#7E7E7E"
              />
            </div>
            <span class="nav__text">
                Coach Schedule
            </span>
          </router-link>
        </li>
        <li class="has__subnav">
          <router-link to="/coach/#">
            <div class="has__subnav__icon">
              <SimulatorIcon
                width="22px"
                height="22px"
                color="#7E7E7E"
              />
            </div>
            <span class="nav__text">
                Session Simulator
            </span>
          </router-link>
        </li>
      </ul>
    </nav>
    <nav class="main__menu__mobile hidden-md-and-up">
      <v-toolbar-side-icon
        fixed
        top
        @click.stop="toggleShow">
      </v-toolbar-side-icon>

      <v-navigation-drawer
        v-model="isShowing"
        absolute
        temporary
      >
        <v-list class="pa-1">
          <v-list-tile avatar tag="div">
            <v-list-tile-avatar>
              <img src="../../assets/img/dualipa.jpg">
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>Suci Andriana</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-list class="pt-0" dense>
          <v-divider light></v-divider>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>Account</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>Setting</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>Sign Out</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
    </nav>
  </div>
</template>

<script>
import DashboardIcon from '../../components/icons/DashboardIcon'
import BookacoachIcon from '../../components/icons/BookacoachIcon'
import SimulatorIcon from '../../components/icons/SimulatorIcon'

import { toggle } from '../../components/mixins/toggle.js'

export default {
  mixins: [toggle],
  components: {
    DashboardIcon,
    BookacoachIcon,
    SimulatorIcon
  },
  data () {
    return {
      items: [
        { title: 'Dashboard', icon: 'dashboard' },
        { title: 'Book a Coach', icon: 'question_answer' },
        { title: 'Study Dashboard', icon: 'dashboard' },
        { title: 'Sessions', icon: 'question_answer' },
        { title: 'Tokens', icon: 'dashboard' },
        { title: 'Session Simulator', icon: 'question_answer' }
      ],
      mini: false,
      right: null
    }
  }
}
</script>

<style lang="scss">
  @import '../../views/content/Sidenav.scss';
</style>



// WEBPACK FOOTER //
// src/coach-components/CoachLayout/CoachSidenav.vue